/**
 * Persist in-progress booking across full-page OAuth redirects (Google/Facebook).
 * Email/password login keeps React state in memory; OAuth remounts the app.
 */

export const PENDING_BOOKING_DRAFT_KEY = 'pendingBookingDraft'

export function savePendingBookingDraft(draft) {
  try {
    if (!draft) return
    const hasServices = Array.isArray(draft.bookingData?.services) && draft.bookingData.services.length > 0
    if (!draft.showServiceBooking && !draft.showTeamBooking && !hasServices) {
      return
    }

    // Also snapshot the Services-page selection UI so professional checkmarks survive OAuth.
    let servicesBookingSummary = draft.servicesBookingSummary || null
    if (!servicesBookingSummary) {
      try {
        const raw = localStorage.getItem('servicesBookingSummary')
        if (raw) servicesBookingSummary = JSON.parse(raw)
      } catch (_) {
        /* ignore */
      }
    }
    if (!servicesBookingSummary && hasServices) {
      servicesBookingSummary = draft.bookingData.services.map((service) => {
        const professional =
          service.professional || service.selectedProfessional || null
        return {
          service: {
            id: service.id,
            name: service.name,
            price: service.price,
            duration: service.duration,
            description: service.description,
            category_id: service.category_id,
            category: service.category || null,
          },
          professional: professional
            ? {
                id: professional.id,
                name: professional.name,
                image: professional.image,
                image_url: professional.image_url,
                role: professional.role,
                specialty: professional.specialty,
                rating: professional.rating,
              }
            : null,
          category: service.category
            ? { id: service.category.id, name: service.category.name }
            : service.category_id
            ? { id: service.category_id, name: service.categoryName || null }
            : null,
        }
      }).filter((item) => item.service?.id && item.professional?.id)
    }

    localStorage.setItem(
      PENDING_BOOKING_DRAFT_KEY,
      JSON.stringify({
        ...draft,
        servicesBookingSummary,
        savedAt: Date.now(),
      })
    )
  } catch (error) {
    console.warn('Failed to save pending booking draft', error)
  }
}

export function loadPendingBookingDraft(maxAgeMs = 2 * 60 * 60 * 1000) {
  try {
    const raw = localStorage.getItem(PENDING_BOOKING_DRAFT_KEY)
    if (!raw) return null
    const draft = JSON.parse(raw)
    if (!draft || typeof draft !== 'object') {
      clearPendingBookingDraft()
      return null
    }
    if (draft.savedAt && Date.now() - draft.savedAt > maxAgeMs) {
      clearPendingBookingDraft()
      return null
    }
    return draft
  } catch (error) {
    console.warn('Failed to load pending booking draft', error)
    clearPendingBookingDraft()
    return null
  }
}

export function clearPendingBookingDraft() {
  try {
    localStorage.removeItem(PENDING_BOOKING_DRAFT_KEY)
  } catch (_) {
    /* ignore */
  }
}
